<template>
  <div id="userHome">
    <div class="userDetail">
      <div
        class="userHome-left"
        :style="{ marginLeft: userLeft, width: userLeftWidth }"
      >
        <div class="isShopple" @click="toggleCollapsed">
          <a-icon type="left" v-if="leftshow" />
          <a-icon type="right" v-else />
        </div>
        <div class="user-left-con">
          <div class="user-left-search">
            <a-form :form="searchForm">
              <a-row type="flex" justify="start">
                <a-col>
                  <a-form-item>
                    <a-input
                      placeholder="Basic usage"
                      style="width: 200px"
                      v-decorator="['keyword']"
                    />
                  </a-form-item>
                </a-col>
                <a-col>
                  <a-form-item>
                    <a-select
                      placeholder="Basic usage"
                      style="width: 150px"
                      allowClear
                      v-decorator="['status']"
                    >
                      <a-select-option value="0">Inactive</a-select-option>
                      <a-select-option value="1">Active</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col style="marginTop:8px">
                  <a-button
                    type="primary"
                    shape="circle"
                    icon="search"
                    size="small"
                    @click="SearchUserInfo"
                  ></a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-row type="flex" justify="start" style="margin: 0 0 8px 0">
            <a-col>
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Edit</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="edit"
                  style="background: #9c9446;border:none"
                  @click="edituser"
                ></a-button>
              </a-tooltip>
            </a-col>
            <a-col style="margin: 0 8px">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Come into force</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="safety"
                  @click="logoutEffect('Effect')"
                >
                </a-button>
              </a-tooltip>
            </a-col>
            <a-col>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>log off</span>
              </template>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="poweroff"
                      style="background: #a0e45d;border:1px solid #a0e45d"
                      @click="logoutEffect('logout')"
              >
              </a-button>
            </a-tooltip>
          </a-col>
            <a-col>
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Empower</span>
                </template>
                <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="usergroup-add"
                        style="background: #1890ff;border:1px solid #1890ff;margin: 0 10px"
                        @click="empowerEvent"
                >
                </a-button>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-table
            :rowSelection="{
              selectedRowKeys: userRowKeys,
              onChange: onSelectChange
            }"
            :dataSource="userData"
            :columns="userColumns"
            :pagination="NOpagination"
            :customRow="customRowEvent"
            :rowClassName="rowClassName"
            :loading="userTableLoading"
            size="small"
          >
            <template
              v-for="(item, index) in scopedSlotsArray"
              :slot="item"
              slot-scope="text"
            >
              <span :key="index">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ text == null ? "-" : text }}</span>
                  </template>
                  <div>{{ text == null ? "-" : text | SubLength }}</div>
                </a-tooltip>
              </span>
            </template>
          </a-table>
          <a-pagination
            style="textAlign:right;margin:4px"
            size="small"
            :total="userTotal"
            :pageSize="pageSize"
            @change="changePageNum"
            showQuickJumper
          />
        </div>
      </div>
      <div
        class="center-line"
        @mousedown.prevent="dragStart"
        :style="{ left: proxyDomLeft }"
      ></div>
      <div class="userHome-right" :style="{ width: userRightWidth }">
        <div class="user-right-con">
          <a-row type="flex" justify="start">
            <a-col :span="7">
              <a-form :form="roleForm">
                <a-form-item label="Role" v-bind="formItemLayout">
                  <a-select
                    placeholder="Please select"
                    style="width: 100%"
                    allowClear
                    v-decorator="[
                      'roleid',
                      {
                        rules: [{ required: true, message: 'Required' }]
                      }
                    ]"
                  >
                    <a-select-option
                      v-for="item in roleListData"
                      :key="item.uid"
                      >{{ item.roleName }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
            </a-col>
            <a-col style="marginTop:8px;">
              <a-button
                size="small"
                type="primary"
                shape="circle"
                icon="plus"
                style="margin-left: 10px;"
                @click="copyRoleAuthority"
              >
              </a-button>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="start"
            style="borderBottom: 1px solid #efefef;padding: 6px"
            v-if="recordUserUid != ''"
          >
            <a-col>
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Save</span>
                </template>
                <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="check"
                  @click="checkUserTree"
                >
                </a-button>
              </a-tooltip>
            </a-col>
          </a-row>
          <div style="overflow-y: auto;height: 70vh">
            <a-spin :spinning="spinning">
              <a-directory-tree
                checkable
                @select="onSelect"
                :showIcon="false"
                :treeData="treeUserData"
                v-model="checkedKeys"
                :checkedKeys="checkedKeys"
              >
              </a-directory-tree>
            </a-spin>
          </div>
        </div>
      </div>
    </div>


    <!--edit弹窗-->
    <a-modal
      title="Edit User"
      v-model="visibleuserEdit"
      width="70%"
      v-if="userEditData != ''"
      @cancel="userSeting"
    >
      <template slot="footer">
        <a-button type="danger" @click="userSeting">Clear</a-button>
        <a-button type="primary" @click="getUserInfo" :loading="userGetLoading">OK</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="User Account" v-bind="userEditLayout">
              <a-input
                placeholder="User Account"
                disabled
                v-decorator="[
                  'userAccount',
                  {
                    initialValue: userEditData.user.userAccount
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="Email" v-bind="userEditLayout">
              <a-input
                placeholder="Email"
                v-decorator="[
                  'email',
                  {
                    initialValue: userEditData.user.email,
                     rules: [
                        {
                          type: 'email',
                          message: 'The input is not valid E-mail!',
                        },
                        {
                          required: true,
                          message: 'Please input your E-mail!',
                        },
                      ],
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item
              v-bind="userEditLayout"
              label="First Name"
            >
              <a-input
                autocomplete="off"
                placeholder="First Name"
                style="width: 100%"
                v-decorator="[
                  'firstName',
                  {
                    initialValue: userEditData.user.firstName,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              v-bind="userEditLayout"
              label="Middle Name"
            >
              <a-input
                placeholder="Middle Name"
                autocomplete="off"
                style="width: 100%"
                v-decorator="[
                  'middleName',
                  {
                    initialValue: userEditData.user.middleName
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item
              v-bind="userEditLayout"
              label="Last Name"

            >
              <a-input
                placeholder="Last Name"
                autocomplete="off"
                style="width: 100%"
                v-decorator="[
                  'lastName',
                  {
                    initialValue: userEditData.user.lastName,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              v-bind="userEditLayout"
              label="Display Name"
            >
              <a-input
                placeholder="Display Name"
                autocomplete="off"
                style="width: 100%"
                v-decorator="[
                  'dispName',
                  {
                    initialValue: userEditData.user.dispName,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              v-bind="userEditLayout"
              label="Title"
            >
              <a-input
               placeholder="Title"
                autocomplete="off"
                style="width: 100%"
                v-decorator="[
                  'title',
                  {
                    initialValue: userEditData.user.title
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item v-bind="userEditLayout" label="Gender">
              <a-select
                  style="width: 100%"
                  allowClear
                  placeholder="Gender"
                  v-decorator="[
                  'gender',
                  {
                    initialValue:  userEditData.user.gender
                  }
                ]"
              >
                <a-select-option value="Male">Male</a-select-option>
                <a-select-option value="Female">Female</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" v-if="userEditData.systemAdminMark">
            <a-form-item label="Company" v-bind="userEditLayout">
              <a-select style="width: 100%" placeholder="Company"
                 v-decorator="[
                  'companyName',
                  {
                    initialValue: userEditData.user.companyName,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]">
                <a-select-option v-for="item in userEditData.companyList" :value="item.orgCode">{{item.displayName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="Department" v-bind="userEditLayout">
              <a-input
                autocomplete="off"
                style="width: 100%"
                placeholder="Department"
                v-decorator="[
                  'departName',
                  {
                    initialValue: userEditData.user.departName,
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="Position" v-bind="userEditLayout">
              <a-input
                autocomplete="off"
                style="width: 100%"
                placeholder="Position"
                v-decorator="[
                  'position',
                  {
                    initialValue: userEditData.user.position,
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="Telephone" v-bind="userEditLayout">
              <a-input
                autocomplete="off"
                style="width: 100%"
                placeholder="Telephone"
                v-decorator="[
                  'telNum',
                  {
                    initialValue: userEditData.user.telNum,
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="City" v-bind="userEditLayout">
              <a-cascader
                      :options="cityOptions"
                      @change="cityChange"
                      :loadData="cityLoadData"
                      placeholder="Please select"
                      changeOnSelect
                      :fieldNames="{ value: 'ebplCode', label: 'ebplNameEn', children: 'children' }"
                      v-if="isEditCity"
              />
              <div v-else>
                <span >{{userEditData.user.address == '' ? '---' : userEditData.user.address}}</span>
                <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="edit"
                        style="background: #9c9446;border:none;margin-left: 10px;"
                        @click="isEditCityEvent"
                ></a-button>
              </div>

            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="TimeZone" v-bind="userEditLayout">
              <a-select
                style="width: 100%"
                allowClear
                placeholder="TimeZone"
                v-decorator="[
                  'timeZone',
                  {
                    initialValue: userEditData.user.timeZone,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              >
                <a-select-option
                        v-for="(ii, index) in userItmezone"
                        :value="ii.key"
                        :key="index"
                >{{ ii.englishName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
              <a-form-item label="Default Language" v-bind="userEditLayout">
                <a-select
                  style="width: 100%"
                  allowClear
                  placeholder="Default Language"
                  v-decorator="[
                  'defaultLang',
                  {
                    initialValue: userEditData.user.defaultLang,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
                >
                  <a-select-option value="0">简体中文</a-select-option>
                  <a-select-option value="1">繁体中文</a-select-option>
                  <a-select-option value="2">English</a-select-option>
                </a-select>
              </a-form-item>
          </a-col>
        </a-row>
        <a-tabs>
          <a-tab-pane key="1">
            <span slot="tab">Project</span>
            <a-row style="margin: 20px 0" v-if="userEditData.systemAdminMark">
              <a-button
                size="small"
                type="primary"
                shape="circle"
                icon="plus"
                style="margin-right: 14px"
                @click="addPJWH('PJ')"
              ></a-button>

              <a-popconfirm
                title="Delete the selected record(s)?"
                @confirm="deletePJWH('PJ')"
                okText="Yes"
                cancelText="No"
              >
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Delete</span>
                  </template>
                  <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="delete"
                    style="background: #f5222d;border:none"
                  ></a-button>
                </a-tooltip>
              </a-popconfirm>
            </a-row>
            <a-table
              :rowSelection="{
                selectedRowKeys: selectProjectRowKeys,
                onChange: onSelectProjectChange
              }"
              :dataSource="userEditData.products"
              :columns="ProjectColumns"
              size="small"
            >
              <template
                v-for="(item, index) in ProjectSlotsArray"
                :slot="item"
                slot-scope="text"
              >
                <span :key="index">
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span class="tableFontSize">{{
                        text === null ? "-" : text
                      }}</span>
                    </template>
                    <div class="tableFontSize">
                      {{ text === null ? "-" : text | SubLength }}
                    </div>
                  </a-tooltip>
                </span>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">Warehouse</span>
            <a-row style="margin: 20px 0">
              <a-button
                size="small"
                type="primary"
                shape="circle"
                icon="plus"
                style="margin-right: 14px"
                @click="addPJWH('WH')"
              ></a-button>
              <a-popconfirm
                title="Delete the selected record(s)?"
                @confirm="deletePJWH('WH')"
                okText="Yes"
                cancelText="No"
              >
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Delete</span>
                  </template>
                  <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="delete"
                    style="background: #f5222d;border:none"
                  ></a-button>
                </a-tooltip>
              </a-popconfirm>
            </a-row>
            <a-table
              :rowSelection="{
                selectedRowKeys: selectWarehouseRowKeys,
                onChange: onSelectWarehouseChange
              }"
              :dataSource="userEditData.warehouses"
              :columns="WarehouseColumns"
              size="small"
            >
              <template
                v-for="(item, index) in WarehouseSlotsArray"
                :slot="item"
                slot-scope="text"
              >
                <span :key="index">
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span class="tableFontSize">{{
                        text === null ? "-" : text
                      }}</span>
                    </template>
                    <div class="tableFontSize">
                      {{ text === null ? "-" : text | SubLength }}
                    </div>
                  </a-tooltip>
                </span>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </a-modal>

    <!--addProject-->
    <a-modal title="addProject" v-model="addPJWHvis" width="50%">
      <template slot="footer">
        <a-button type="primary" @click="addPJWHApi" :loading="addPJWHBtnLoding"
          >OK</a-button
        >
      </template>
      <a-table
        :dataSource="addPJWHdata"
        :columns="addPJWColumns"
        :rowSelection="{
          selectedRowKeys: PJWHRowKeys,
          onChange: onPJWHChange
        }"
        size="small"
      >
        <template
          v-for="(item, index) in addPJWHArray"
          :slot="item"
          slot-scope="text"
        >
          <span :key="index">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span class="tableFontSize">{{
                  text == null ? "-" : text | SubLength
                }}</span>
              </template>
              <div class="tableFontSize">
                {{ text == null ? "-" : text | SubLength }}
              </div>
            </a-tooltip>
          </span>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
export default {
  data() {
    return {
        tableData:[],
      spinning: false, // tree 加载...
      //        addProject start
      addPJWHdata: [], // 数据
      addPJWColumns: [], // 头
      addPJWHvis: false, // 开关
      addPJWHArray: [], // 头数组
      PJWHRowKeys: [], // chengck 选中index
      PJWHRowRows: [], // chengck 选中val
      PJWHFLAG: "",
      addPJWHBtnLoding: false,
      //        addProject END
      //      编辑表格 start
      ProjectRows: [], // Project所选中 value
      WarehouseRows: [], // Warehouse所选中 value
      selectProjectRowKeys: [], // Project所选中 index
      selectWarehouseRowKeys: [], // Warehouse所选中 index
      WarehouseColumns: [
        {
          title: "Warehouse",
          dataIndex: "whsName",
          scopedSlots: { customRender: "whsName" }
        },
        {
          title: "Address",
          dataIndex: "Address",
          scopedSlots: { customRender: "Address" }
        }
      ], // Warehouse表头
      WarehouseSlotsArray: ["whsName", "Address"],
      ProjectSlotsArray: ["projectName", "orgName"],
      ProjectColumns: [
        {
          title: "Project",
          dataIndex: "projectName",
          scopedSlots: { customRender: "projectName" }
        },
        {
          title: "Organization",
          dataIndex: "orgName",
          scopedSlots: { customRender: "orgName" }
        }
      ], // Project表头
      //      编辑表格 END
      userRowKeys: [], // userTable 选中的index
      userRows: [], // userTable 选中的数据
      userTableLoading: true,
      pageSize: 10,
      userTotal: 0,
      //        树结构数据
      treeUserData: [], // 树的数据
      roleListData: [],
      checkedKeys: [], // 默认选中
      selectedKeys: [], // 选中的数据

      patt1: "^[a-zA-Z]+$",
      form: this.$form.createForm(this),
      searchForm: this.$form.createForm(this),
      roleForm: this.$form.createForm(this),
      userEditData: "", // 编辑请求data
      userEditLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      visibleuserEdit: false, // 编辑弹窗
      proxyDomLeft: "", // 拖拽line
      userRightWidth: "", //  右宽
      userLeft: "", // 左left
      userLeftWidth: "", // 左宽
      leftshow: true,
      scopedSlotsArray: ["UserAccount", "UserName", "Status"],
      userColumns: [
        {
          title: "User Account",
          dataIndex: "UserAccount",
          scopedSlots: { customRender: "UserAccount" }
        },
        {
          title: "User Name",
          dataIndex: "UserName",
          scopedSlots: { customRender: "UserName" }
        },
        {
          title: "Status",
          dataIndex: "Status",
          scopedSlots: { customRender: "Status" }
        }
      ],
      userData: [],
      NOpagination: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 8 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 8 },
          sm: { span: 16 }
        }
      },
      userGetLoading: false,
      recordUserUid: "", // 点击table 当前UID
      userItmezone: [], // timezone 下拉数据
      cityOptions:[],
      cityArr: [],
      isEditCity: false
    };
  },
  created() {
    this.initData();
    this.initRole();
  },
  methods: {
      isEditCityEvent(){
        this.isEditCity = true
      },
      empowerEvent(){
          let params = {}
          params.uids = []
          if(this.userRows.length < 1){
              this.$customMessage.error('Please select one record at least');
              return
          }
          let userArr = this.userRows
          for(let i in userArr){
              params.uids.push(userArr[i].UID)
          }
          ajax.post(api.USERINVITECODE,params).then(res=>{
            if(res.code == 200){
                this.$message.success(res.msg);
                this.initData()
            }
        })
      },
      cityChange(val ,selectedOptions){
          this.cityArr = val
      },
      cityLoadData(selectedOptions) {
          const targetOption = selectedOptions[selectedOptions.length - 1];
          targetOption.loading = true;
          let params = {
              lang:1
          }
          if(selectedOptions.length > 1){
              params.addressType = 2
              params.address= selectedOptions[1].ebplCode
          }else{
              params.addressType = 1
              params.address= selectedOptions[0].ebplCode
          }
          ajax.post(api.GETUSERADDRESS,params).then(res=>{
              targetOption.loading = false;
              let data = res.data
              for(let i in data){
                  if(selectedOptions.length  ==  1){
                      data[i].isLeaf = false
                  }
              }
              targetOption.children = data
              this.cityOptions = [...this.cityOptions];
          })
      },
    //      获取role 下拉
    initRole() {
      ajax.get(api.USERROLE).then(res => {
        this.roleListData = res.data;
      });
    },
    copyRoleAuthority() {
      this.roleForm.validateFields((err, val) => {
        if (this.userRows.length < 1) {
          this.$customMessage.warning("Please select the list use")
          return;
        } else {
          let checkuid = [];
          this.userRows.forEach(value => {
            checkuid.push(value.UID);
          });
          let params = {
            roleUid: val.roleid,
            userUids: checkuid
          };
          ajax.post(api.USERROLE, params).then(res => {
            if (res.code == 200) {
              this.userTableLoading = true;
              this.initData();
            }
          });
        }
      });
    },
    //      点击表格请求右边权限数据
    customRowEvent(record, index) {
      return {
        on: {
          click: () => {
            for (let i in this.userData) {
              if (i == index) {
                document.querySelectorAll(".tt")[i].classList.add("bg");
              } else {
                document.querySelectorAll(".tt")[i].classList.remove("bg");
              }
            }
            this.recordUserUid = record.UID;
            this.treeAjaxData();
          }
        }
      };
    },
    treeAjaxData() {
      let params = {
        userUid: this.recordUserUid,
        roleUid: ""
      };
      this.spinning = true;
      ajax.get(api.USERPERMISSION, params).then(res => {
        this.treeUserData = res.data;
        let checkTree = [];
        for (let i in this.treeUserData) {
          let aaa = this.treeUserData[i].children;
          for (let iii in aaa) {
            let ttt = aaa[iii].children;
            for (let iii in ttt) {
              if (ttt[iii].checked) {
                checkTree.push(ttt[iii].key);
              }
            }
          }
        }
        this.checkedKeys = checkTree;
        this.spinning = false;
      });
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
    },
    checkUserTree() {
      if (this.recordUserUid == "") {
        return;
      }
      let getArr = this.checkedKeys;
      let paramsArr = [];
      for (let index in getArr) {
        if (isNaN(getArr[index])) {
          paramsArr.push(getArr[index]);
        }
      }
      let parasm = {
        functionList: paramsArr,
        userUid: this.recordUserUid
      };
      ajax.post(api.USERPERMISSION, parasm).then(res => {
        if (res.code == 200) {
          this.$message.success("Save successfully");
          this.treeAjaxData();
        }
      });
    },
    //      table class
    rowClassName(record, index) {
      if (index % 2 == 0) {
        return "cc tt";
      } else {
        return "hh tt";
      }
    },
    //      table选择
    onSelectChange(selectedRowKeys, selectedRows) {
      this.userRowKeys = selectedRowKeys;
      this.userRows = selectedRows;
    },
    onSelectProjectChange(selectedRowKeys, selectedRows) {
      this.selectProjectRowKeys = selectedRowKeys;
      this.ProjectRows = selectedRows;
    },
    onSelectWarehouseChange(selectedRowKeys, selectedRows) {
      this.selectWarehouseRowKeys = selectedRowKeys;
      this.WarehouseRows = selectedRows;
    },
    //      编辑弹窗出现 值
    edituser() {
      if (this.userRows.length != 1) {
        this.$customMessage.warning("Please select one record at least");
        return;
      }
        ajax.get(api.TIMEZONE).then(res => {
            this.userItmezone = res.data
        });
      let params = {
        uid: this.userRows[0].UID
      };
      ajax.get(api.USEREDIT, params).then(res => {
        this.userEditData = res.data;
        this.visibleuserEdit = true;
        this.selectWarehouseRowKeys = [];
        this.selectWarehouseRowKeys = [];

          let param = {
              addressType:0,
              address:"",
              lang:1
          }
          ajax.post(api.GETUSERADDRESS,param).then(res=>{
              this.cityOptions = res.data
              for(let i in this.cityOptions){
                  this.cityOptions[i].isLeaf = false
              }
          })

      });
    },
    //      初始化数据
    initData(pageNum = 1, val) {
      let params = {
        pageNum: pageNum,
        pageSize: this.pageSize
      };
      if (val) {
        (params.keyword = val.keyword), (params.status = parseInt(val.status));
      }
      ajax.get(api.USER, params).then(res => {
        this.userData = res.data.content;
        this.userTotal = res.data.totalElements;
        this.userTableLoading = false;
        this.userRowKeys = [];
      });
    },
    //      分页
    changePageNum(page) {
      this.initData(page);
    },
    //      search
    SearchUserInfo() {
      this.searchForm.validateFields((err, val) => {
        this.initData(1, val);
      });
    },
    //      user编辑提交请求
    getUserInfo() {
      this.userGetLoading = true;
      this.form.validateFields((err, val) => {
        if (!err) {
          let params = val;
          params.city =  this.cityArr
          params.uid = this.userRows[0].UID;
            ajax.put(api.USER, params).then(res => {
            if (res.code == 200) {
              this.visibleuserEdit = false;
              this.userGetLoading = false;
              this.isEditCity = false
              this.initData()
              this.userEditData = ''
              this.$message.success(res.msg);
            }else{
                this.$customMessage.error(res.msg);
                return
            }
          });
        } else {
          this.userGetLoading = false;
        }
      });
    },
    //      添加Project Warehouse
    addPJWH(type) {
      this.addPJWColumns = [];
      this.addPJWHArray = [];
      let params = {};
      params.uid = this.userRows[0].UID;
      if (type == "WH") {
        ajax.get(api.WHS, params).then(res => {
          this.addPJWColumns.push({
            title: "Warehouse",
            dataIndex: "whsName",
            scopedSlots: { customRender: "whsName" }
          });
          this.addPJWHArray = ["whsName"];
          this.addPJWHdata = res.data;
          this.PJWHFLAG = "WH";
          this.addPJWHvis = true;
        });
      } else if (type == "PJ") {
        ajax.get(api.PROJECT, params).then(res => {
          this.addPJWColumns.push({
            title: "Project",
            dataIndex: "ProjectName",
            scopedSlots: { customRender: "ProjectName" }
          });
          this.addPJWHArray = ["ProjectName"];
          this.addPJWHdata = res.data;
          this.PJWHFLAG = "PJ";
          this.addPJWHvis = true;
        });
      }
    },
    //      删除Project Warehouse
    deletePJWH(type) {
      if (type == "WH") {
        if (this.WarehouseRows.length < 1) {
          this.$customMessage.warning("Please select one record at least");
          return;
        }
        let checkuid = [];
        this.WarehouseRows.forEach(value => {
          checkuid.push(value.uid);
        });
        let params = {
          uids: checkuid,
          userUid: this.userRows[0].UID
        };

        ajax.delete(api.WHS, params).then(res => {
          if (res.code == 200) {
            this.edituser();
          }
        });
      } else if (type == "PJ") {
        if (this.ProjectRows.length < 1) {
          this.$customMessage.warning("Please select one record at least");
          return;
        }
        let checkuid = [];
        this.ProjectRows.forEach(value => {
          checkuid.push(value.uid);
        });
        let params = {
          uids: checkuid,
          userUid: this.userRows[0].UID
        };
        ajax.delete(api.PROJECT, params).then(res => {
          if (res.code == 200) {
            this.edituser();
          }
        });
      }
    },
    //      Project Warehouse 选中
    onPJWHChange(selectedRowKeys, selectedRows) {
      this.PJWHRowKeys = selectedRowKeys;
      this.PJWHRowRows = selectedRows;
    },
    //      Project Warehouse 选中提交ajax
    addPJWHApi() {
      this.addPJWHBtnLoding = true;
      let checkuid = [];
      this.PJWHRowRows.forEach(value => {
        checkuid.push(value.uid);
      });
      let params = {
        uids: checkuid,
        userUid: this.userRows[0].UID
      };
      if (this.PJWHFLAG == "WH") {
        ajax.post(api.WHS, params).then(res => {
          if (res.code == 200) {
            this.addPJWHvis = false;
            this.addPJWHBtnLoding = false;
            this.edituser();
          }
        });
      } else if (this.PJWHFLAG == "PJ") {
        ajax.post(api.PROJECT, params).then(res => {
          if (res.code == 200) {
            this.addPJWHvis = false;
            this.addPJWHBtnLoding = false;
            this.edituser();
          }
        });
      }
    },
    //      user重置
    userSeting() {
      this.form.resetFields();
    },

    //      注销生效
    logoutEffect(type) {
      if (type == "logout") {
        if (this.userRows.length < 1) {
          this.$customMessage.warning("Please select one record at least");
          return;
        }
        this.logoutEffectAjax(0);
      } else if (type == "Effect") {
        if (this.userRows.length < 1) {
          this.$customMessage.warning("Please select one record at least");
          return;
        }
        this.logoutEffectAjax(1);
      }
    },
    logoutEffectAjax(type) {
      let checkuid = [];
      this.userRows.forEach(v => {
        checkuid.push(v.UID);
      });
      let params = {
        modifier: "",
        status: type,
        uids: checkuid
      };
      ajax.put(api.USERSTAS, params).then(res => {
        if (res.code == 200) {
          this.initData();
        }
      });
    },

    //      页面拖拽伸缩
    toggleCollapsed() {
      this.leftshow = !this.leftshow;
      if (!this.leftshow) {
        this.proxyDomLeft = "20px";
        this.userLeftWidth = "20px";
        this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
      } else {
        setTimeout(() => {
          this.proxyDomLeft = "50%";
          this.userLeftWidth = this.proxyDomLeft;
          this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
        }, 300);
      }
    },
    dragStart(e) {
      let odiv = e.target;
      let disX = e.clientX - odiv.offsetLeft;
      let that = this;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let zWidth =
          document.querySelectorAll(".userDetail")[0].offsetWidth - 40;
        if (zWidth < left) {
          return false;
        }
        if (left < 20) {
          return false;
        } else {
          that.proxyDomLeft = left + "px";
          that.userLeftWidth = that.proxyDomLeft;
          that.userRightWidth = `calc(100% - ${that.userLeftWidth})`;
        }
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
};
</script>
<style lang="less">
/*抽屉框架样式*/
.tt {
}
.bg {
  background: darkseagreen !important;
}
.cc {
  background: #fff;
}
.hh {
  background: #e7eef8;
}
.ant-checkbox-group {
  .ant-checkbox-group-item {
    display: block;
    margin-top: 4px;
  }
}
.drawerCheckClass {
  .drawerCheckHeader {
    border-bottom: 1px solid #e9e9e9;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
#userHome {
  .userDetail {
    position: relative;
    height: 100%;
    overflow: hidden;
    background: #fff;
    .userHome-left {
      width: 50%;
      height: 100%;
      float: left;
      padding: 10px;
      position: relative;
      .isShopple {
        position: absolute;
        top: 0;
        right: -32px;
        z-index: 999;
        background: #efefef;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.8;
      }
      .user-left-con {
        overflow: hidden;
        .user-left-search {
          width: 500px;
          div {
            margin-right: 4px;
          }
        }
      }
    }
    .center-line {
      position: absolute;
      cursor: w-resize;
      left: 50%;
      height: 100%;
      border: 1px solid #efefef;
    }
    .userHome-right {
      float: right;
      width: calc(100% - 50%);
      height: 100%;
      padding: 10px;
      .user-right-con {
        overflow: hidden;
      }
    }
  }
}
</style>
